// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606041339/js/" + chunkId + "." + {"44":"62f993e5","225":"84803241","481":"ac39d1ca","486":"e21224c2","770":"70ef455e"}[chunkId] + ".0.6448400027325869.chunk.js";
};